module.exports = __webpack_public_path__ + "static/media/aq.424414e6.svg";